import {
  ProviderIcon as SharedProviderIcon,
  type ProviderIconProps as SharedProviderIconProps,
} from 'pi-kiosk-shared/ui';

export type ProviderIconProps = SharedProviderIconProps;

export const ProviderIcon = SharedProviderIcon;
